import { RcThemeInput } from '@ringcentral/juno';
import { overridesFactory } from '@/shared/theme/utils/overrides.factory';
import { paletteFactory } from '@/shared/theme/utils/palette.factory';

export const btColor = '#5514B4';

export const btTheme: RcThemeInput = {
  palette: paletteFactory(btColor),
  overrides: overridesFactory(btColor),
};
